var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"copyright"},[_vm._v("© "+_vm._s(_vm.currentYear)+" Service Portal v"+_vm._s(_vm.version))]),_c('div',{staticClass:"made-by"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }